<template>
  <v-dialog v-model="isDialogVisible" max-width="650">
    <v-card class="add-person-dialog">
      <v-btn class="button-close ma-4" icon @click="close()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-card-title>
        <h4 class="mt-1">Выбeрите кандидатов</h4>
      </v-card-title>
      <v-card-text>
        <SelectCandidateTable :selected="selectedCandidates" />
        <div class="d-flex justify-end mt-2 mb-3">
          <v-btn outlined color="primary" @click="close()" class="mr-4 px-6">Отменить</v-btn>
          <v-btn color="primary" class="px-9" @click="onNext()" :disabled="!selectedCandidates.length">Далее</v-btn>
        </div>
      </v-card-text>
    </v-card>
    <SelectDossierDialog v-model="showDossierDialog" @ok="onOk"/>
  </v-dialog>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { cloneDeep } from 'lodash';
import SelectCandidateTable from './SelectCandidateTable.vue';
import SelectDossierDialog from './SelectDossierDialog.vue';

export default {
name: 'AddProfrgamsDialog',
components: {
  SelectCandidateTable, SelectDossierDialog 
},
model: {
  prop: 'value',
  event: 'input',
},
props: {
  value: Boolean,
},
data: () => ({
  strFilter: "",
  selectedCandidates: [],
  showDossierDialog: false,
}),
watch: {
  async value(val) {
    if (val) {
      this.selectedCandidates = cloneDeep(this.srcCandidates ?? [])
      // await this.loadCustomers();
    }
  },
},
computed: {
  ...mapGetters({
    srcCandidates: 'ai/dossier/selectedCandidates',
    user: 'auth/user',
  }),
  isDialogVisible: {
    get() {
      return this.value;
    },
    set(value) {
      if (!value) {
        this.close()
      }
    },
  },
  filter () {
      return (item, search, textKey) => {
        return item[textKey].indexOf(search) > -1
      }
    },

},
methods: {
  ...mapActions({
  }),
  ...mapMutations({
    setSelectedCandidates: 'ai/dossier/setSelectedCandidates',

  }),
  close(ret) {
    this.$emit('input', ret);
  },
  onNext(ret) {
    this.setSelectedCandidates(cloneDeep(this.selectedCandidates))
    this.showDossierDialog = true
  },
  onOk() {
    this.$emit('ok');
    this.close()
  },
}

}
</script>

<style>
.add-person-dialog .v-tab {
  text-transform: capitalize !important;
  font-weight: bold;
}

.add-person-dialog .v-data-footer__pagination{
  margin: 0 5px;
}

.tree-view-container {
height: 300px;
overflow: auto;
border: 1px solid #ccc;
border-radius: 3px;
}

.selected-count {
font-size: 12px;
}
</style>
